export default __webpack_public_path__ + "static/media/yellow-01-b.3061e83d.png";